import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatMaterialStatusLabel } from '#/modules/momMgmt/analysis/orders/helper/materialStatus';

const MaterialStatusBadge = ({
  status,
  size = 'default',
  className,
  onClick,
}) => (
  <StatusBadge
    status={status}
    label={formatMaterialStatusLabel(status)}
    size={size}
    className={className}
    onClick={onClick}
  />
);

MaterialStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default MaterialStatusBadge;
